import Vue from 'vue'
import Router from 'vue-router'
import LayOut from '@/components/Layout.vue'
import Home from '@/views/home.vue'

//Company
import AboutUs from '@/views/Company/AboutUs.vue'
import CoreCompetencies from '@/views/Company/CoreCompetencies.vue'
import Affiliates from '@/views/Company/Affiliates.vue'
import Sustainability from '@/views/Company/Sustainability.vue'
import EthicalManagement from '@/views/Company/EthicalManagement.vue'
import SustainableReport from '@/views/Company/SustainableReport.vue'

//Technology
import TechnologySolutions from '@/views/Technology/TechnologySolutions.vue'
import InjectionMolding from '@/views/Technology/InjectionMolding.vue'
import Surface from '@/views/Technology/Surface.vue'
import Forming from '@/views/Technology/Forming.vue'
import Composite from '@/views/Technology/Composite.vue'
import Material from '@/views/Technology/Material.vue'

//Industries
// import Expertise from '@/views/Industries/Expertise.vue'
// import Automotive from '@/views/Industries/Automotive.vue'
// import Consumer from '@/views/Industries/Consumer.vue'
// import Industrial from '@/views/Industries/Industrial.vue'

//Services 
import Capabilities from '@/views/Services/Capabilities.vue'
import Certifications from '@/views/Services/Certifications.vue'
import EngineeringConsulting from '@/views/Services/EngineeringConsulting.vue'
import Prototyping from '@/views/Services/Prototyping.vue'
import TestingLaboratory from '@/views/Services/TestingLaboratory.vue'
// import Automation from '@/views/Services/Automation.vue'

//News
// import News from '@/views/News/News.vue'
// import PressReleases from '@/views/News/PressReleases.vue'
// import UpcomingEvents from '@/views/News/UpcomingEvents.vue'
// import Blog from '@/views/News/Blog.vue'
// import NewsLetter from '@/views/News/NewsLetter.vue'

//ContactUs
import Locations from '@/views/ContactUs/Locations.vue'
import FAQ from '@/views/ContactUs/FAQ.vue'
import ContactUs from '@/views/ContactUs/ContactUs.vue'

//Footer
import PrivacyPolicy from '@/views/Footer/PrivacyPolicy.vue'
import CookiePolicy from '@/views/Footer/CookiePolicy.vue'
import TermsUse from '@/views/Footer/TermsUse.vue'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path:'/',
      component:LayOut,
      name:"main",
      hideMenu:true,
      children:[
        {
          path:'/',
          component:Home,
          name:'home',
        }
      ]
    },
    {
      path:'/',
      component:LayOut,
      name:'Footer',
      hideMenu:true,
      children:[
        {
          path:'/PrivacyPolicy',
          component:PrivacyPolicy,
          name:"PrivacyPolicy"
        },
        {
          path:'/CookiePolicy',
          component:CookiePolicy,
          name:"CookiePolicy"
        },
        {
          path:'/TermsUse',
          component:TermsUse,
          name:"TermsUse"
        }
      ]
    },
    {
      path: '/',
      component: LayOut,
      name:"Company",
      namecn:'公司',
      namecht:"公司",
      namejp:"会社",
      children:[
        {
          path:'/AboutUs',
          component:AboutUs,
          name:"About Us",
          namecn:"关于我们",
          namecht:"關於我們",
          namejp:"当社について",
        },{
          path:'/Affiliates',
          component:Affiliates,
          name:"Affiliates",
          namecn:"关系企业",
          namecht:"關係企業",
          namejp:"関連会社",
        },{
          path:'/CoreCompetencies',
          component:CoreCompetencies,
          name:'CORE VALUE',
          namecn:"核心竞争力",
          namecht:"核心競爭力",
          namejp:"コア・コンピテンシー",
        },{
          path:'/Sustainability',
          component:Sustainability,
          name:'Sustainability',
          namecn:"可持续发展",
          namecht:"可持續發展",
          namejp:" サステナビリティ"
        },{
          path:'/EthicalManagement',
          component:EthicalManagement,
          name:'Ethical Corporate Management',
          namecn:"诚信经营",
          namecht:"誠信經營",
          namejp:"誠実経営"
        },{
          path:'/SustainableReport',
          component:SustainableReport,
          name:'Sustainable Report',
          namecn:"永续报告",
          namecht:"永續報告",
          namejp:"永続的なレポート"
        }
      ]
    },{
      path:"/",
      component:LayOut,
      name:"Technology",
      namecn:"技术支援",
      namecht:"技術支援",
      namejp:"テクニカルサポート",
      children:[
        {
          path:'/TechnologySolutions',
          component:TechnologySolutions,
          name:'Technology Solutions',
          namecn:"技术解决方案",
          namecht:"技術解決方案",
          namejp:"提案"
        },{
          path:'/InjectionMolding',
          component:InjectionMolding,
          name:'Injection Molding',
          namecn:"射出成型",
          namecht:"射出成型",
          namejp:"射出成形"
        },{
          path:'/Surface',
          component:Surface,
          name:'Cosmetic Finishing',
          namecn:"表面加工",
          namecht:"表面處理",
          namejp:"表面処理"
        },{
          path:'/Forming',
          component:Forming,
          name:'Metal Fabrication',
          namecn:"金属加工",
          namecht:"金属加工",
          namejp:"金屬加工"
        },{
          path:'/Composite',
          component:Composite,
          name:'Composite',
          namecn:"复合材料",
          namecht:"複合材料",
          namejp:"コンポジェット材"
        },{
          path:'/Material',
          component:Material,
          name:'Material',
          namecn:"材料",
          namecht:"材料",
          namejp:"材料"
        }
      ]
    }
    ,{
      path:'/',
      component:LayOut,
      name:'Services',
      namecn:"其他服务",
      namecht:"其他服務",
      namejp:"その他のサービス",
      children:[
        {
          path:'/Capabilities',
          component:Capabilities,
          name:'Capabilities',
          namecn:"核心能力",
          namecht:"核心能力",
          namejp:"コアコンピテンシー"
        },{
          path:'/Certifications',
          component:Certifications,
          name:'Certifications',
          namecn:"公司认证",
          namecht:"公司認證",
          namejp:"公司認證"
        },{
          path:'/EngineeringConsulting',
          component:EngineeringConsulting,
          name:'Engineering & Consulting',
          namecn:"工程与谘询",
          namecht:"工程與諮詢",
          namejp:"エンジニアリング及びコンサルティング"
        },{
          path:'/TestingLaboratory',
          component:TestingLaboratory,
          name:'Testing Laboratory',
          namecn:"测试实验室",
          namecht:"測試實驗室",
          namejp:"試験実験室"
        },{
          path:'/Prototyping',
          component:Prototyping,
          name:'Prototype Designing',
          namecn:"模型设计",
          namecht:"模型設計",
          namejp:"PROTOTYPING"
        }
      ]
    }
    ,{
      path:'/',
      component:LayOut,
      name:'Contact Us',
      namecn:"联络我们",
      namecht:"聯絡我們",
      namejp:"お問い合わせ",
      children:[
        {
          path:'/Locations',
          component:Locations,
          name:"Locations",
          namecn:"地点",
          namecht:"地點",
          namejp:"ロケーション"
        },{
          path:"/FAQ",
          component:FAQ,
          name:"FAQ",
          namecn:"常见问题",
          namecht:"常見問題",
          namejp:"よくあるご質問"
        },{
          path:"/ContactUs",
          component:ContactUs,
          name:'Contact Us',
          namecn:"联络我们",
          namecht:"聯絡我們",
          namejp:"お問い合わせ"
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})




// WEBPACK FOOTER //
// ./src/router/index.js